import { getIconProps, type IconProps } from '#types'

/**
 * Tag icon — price-tag / label shape with a small ring and a diagonal stripe.
 *
 * Used for tag selectors, tag chips, and "type"/"label" UI.
 *
 * @example
 * ```tsx
 * <TagIcon className="h-5 w-5" />
 * ```
 */
export function TagIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M15.2607 3.75098C15.9782 3.72352 16.723 4.16029 17.0811 4.81055C17.7287 5.98681 18.5785 7.60189 19.2412 9.02441C19.5733 9.73733 19.8514 10.3875 20.0342 10.9033C20.1259 11.1621 20.1877 11.3717 20.2217 11.5293C20.2429 11.6281 20.2475 11.682 20.249 11.7021C20.2296 11.7779 20.1629 11.9812 20.0186 12.3154C19.8713 12.6563 19.6649 13.0904 19.4072 13.5811C18.8911 14.5639 18.1795 15.7528 17.3408 16.8574C16.4969 17.9688 15.5539 18.9562 14.583 19.5771C13.6184 20.194 12.7035 20.4042 11.8359 20.1328C11.2195 19.94 9.67777 19.1596 8.09668 18.2529C7.32138 17.8083 6.56077 17.3468 5.93164 16.9355C5.28586 16.5134 4.82658 16.1747 4.61719 15.9707C3.96337 15.3337 3.69976 14.4201 3.75781 13.2705C3.8162 12.115 4.199 10.8084 4.73438 9.5293C5.26667 8.25763 5.93213 7.05515 6.5166 6.12109C7.08735 5.20901 7.54239 4.61647 7.70312 4.44727C7.72199 4.4385 7.76564 4.41909 7.8457 4.39355C7.99513 4.34591 8.20523 4.29627 8.47559 4.24805C9.01435 4.15197 9.72177 4.07293 10.5117 4.00684C12.0885 3.87493 13.9249 3.80211 15.2607 3.75098Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="2.27208"
        cy="2.27208"
        r="1.52208"
        transform="matrix(0.866025 0.5 0.5 -0.866025 10.502 9.53833)"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
      <rect
        x="6.91797"
        y="12.7163"
        width="7.57494"
        height="1.51472"
        rx="0.75736"
        transform="rotate(30 6.91797 12.7163)"
        fill="currentColor"
      />
    </svg>
  )
}
